import { NotificationsRes } from '@/api/types/notificationsType';

type TranslateFn = (
  key: string,
  options?: Record<string, string | number>
) => string;

export const getNotificationMessage = (
  translate: TranslateFn,
  notification: NotificationsRes
): string => {
  const params = notification.translation_params ?? undefined;

  const typeBodyKey = `notification.body.${notification.type}`;
  const typeBodyTranslation = translate(typeBodyKey, params);
  if (typeBodyTranslation !== typeBodyKey) {
    return appendContext(typeBodyTranslation, params);
  }

  const typeTitleKey = `notification.title.${notification.type}`;
  const typeTitleTranslation = translate(typeTitleKey, params);
  if (typeTitleTranslation !== typeTitleKey) {
    return appendContext(typeTitleTranslation, params);
  }
  const bodyKey = `notification.body.${notification.body}`;
  const bodyTranslation = translate(bodyKey, params);

  let message =
    bodyTranslation !== bodyKey ? bodyTranslation : notification.body;

  const titleKey = `notification.title.${notification.title}`;
  const titleTranslation = translate(titleKey, params);

  if (message === notification.body && titleTranslation !== titleKey) {
    message = titleTranslation;
  }

  return appendContext(message, params);
};

const appendContext = (
  message: string,
  params?: Record<string, string | number>
): string => {
  if (!params) {
    return message;
  }

  const userName = params.user_name;
  if (userName && typeof userName === 'string' && !message.includes(userName)) {
    message = `${message} — ${userName}`;
  }

  const adminName = params.admin_name;
  if (
    adminName &&
    typeof adminName === 'string' &&
    !message.includes(adminName)
  ) {
    message = `${message} — ${adminName}`;
  }

  const postTitle = params.post_title;
  if (
    postTitle &&
    typeof postTitle === 'string' &&
    postTitle.trim() &&
    !message.includes(postTitle)
  ) {
    message = `${message} (${postTitle})`;
  }

  return message;
};
